// extracted by mini-css-extract-plugin
export default {"charts":"Widgets_charts__NBkPj"};